import * as React from "react";
function SvgIconArrowRightDarkblue(props: React.SVGProps<SVGSVGElement>) {
  return <svg id="b449d084-9bac-4496-8d90-c483b5a9b233" data-name="icon-arrow-right-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12.56" {...props}><title>{"icon-arrow-right-darkblue"}</title><path d="M4.19,6.33,1.05,1.86A13.1,13.1,0,0,0,0,.46L.81,0,3.52,2.74C4.68,3.9,5.84,5,7,6.12v.42L3.13,10.27c-.81.81-1.62,1.55-2.32,2.29L0,12Z" style={{
      fill: "#19384E"
    }} /></svg>;
}
export default SvgIconArrowRightDarkblue;